"use strict"; // TODO: Consider generalizing image component mechanics of AI2Logo See:
// https://github.com/allenai/varnish/pull/210#issuecomment-552137573

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var logo_ai2_fullColor_svg_1 = __importDefault(require("./logos/logo-ai2-fullColor.svg"));

var logo_ai2_fullColor_withText_svg_1 = __importDefault(require("./logos/logo-ai2-fullColor-withText.svg"));

var logo_ai2_fullColor_withText_micro_svg_1 = __importDefault(require("./logos/logo-ai2-fullColor-withText-micro.svg"));

var logo_ai2_white_svg_1 = __importDefault(require("./logos/logo-ai2-white.svg"));

var logo_ai2_white_withText_svg_1 = __importDefault(require("./logos/logo-ai2-white-withText.svg"));

var logo_ai2_white_withText_micro_svg_1 = __importDefault(require("./logos/logo-ai2-white-withText-micro.svg"));

var dimsByLogoSize = {
  micro: {
    width: 177,
    height: 16
  },
  "default": {
    width: 264,
    height: 30
  },
  lg: {
    width: 326,
    height: 37
  }
};
var noTextDimsByLogoSize = {
  micro: {
    width: 34,
    height: dimsByLogoSize.micro.height
  },
  "default": {
    width: 64,
    height: dimsByLogoSize["default"].height
  },
  lg: {
    width: 78,
    height: dimsByLogoSize.lg.height
  }
};

function getDimensionsFromHeight(height, includeText) {
  if (includeText === void 0) {
    includeText = true;
  }

  var byLogoSize = includeText ? dimsByLogoSize : noTextDimsByLogoSize; // Extrapolate custom size aspect ratio based on default size

  var dims = byLogoSize["default"];
  var aspectRatio = dims.width / dims.height;
  return {
    width: aspectRatio * height,
    height: height
  };
}

function getImageDimensions(size, includeText) {
  if (includeText === void 0) {
    includeText = true;
  }

  if (typeof size === 'number') {
    // Used for custom size
    return getDimensionsFromHeight(size, includeText);
  } else {
    // Used in conjunction with predetermined size
    var byLogoSize = includeText ? dimsByLogoSize : noTextDimsByLogoSize;
    return byLogoSize[size];
  }
}

function getImageSrc(size, color, includeText) {
  if (includeText) {
    if (color === 'white') {
      return size === 'micro' ? logo_ai2_white_withText_micro_svg_1["default"] : logo_ai2_white_withText_svg_1["default"];
    } else {
      return size === 'micro' ? logo_ai2_fullColor_withText_micro_svg_1["default"] : logo_ai2_fullColor_withText_svg_1["default"];
    }
  } else {
    return color === 'white' ? logo_ai2_white_svg_1["default"] : logo_ai2_fullColor_svg_1["default"];
  }
} // TODO (@codeviking): Move AI2Logo to `components/ai2`.


exports.AI2Logo = function (_a) {
  var _b = _a.color,
      color = _b === void 0 ? 'default' : _b,
      _c = _a.size,
      size = _c === void 0 ? 'default' : _c,
      _d = _a.includeText,
      includeText = _d === void 0 ? true : _d,
      className = _a.className;

  var _e = getImageDimensions(size, includeText),
      width = _e.width,
      height = _e.height;

  return React.createElement(VectorImage, {
    src: getImageSrc(size, color, includeText),
    className: className,
    width: width,
    height: height,
    alt: "Allen Institute for AI"
  });
};

var VectorImage = styled_components_1["default"].img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n    max-width: 100%;\n"], ["\n    display: block;\n    max-width: 100%;\n"])));
var templateObject_1;